import { render, staticRenderFns } from "./ManagerBlock.vue?vue&type=template&id=1904a94a&scoped=true&"
import script from "./ManagerBlock.vue?vue&type=script&lang=js&"
export * from "./ManagerBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904a94a",
  null
  
)

export default component.exports